import { FC, useContext, useEffect } from 'react';

import mixpanel from 'mixpanel-browser';

import { trackCometlyFactFindSubmitted } from '@App/cometly/cometly';
import { ApplicationContext } from '@App/contexts/Application';
import useConversionTracking from '@src/app/hooks/useConversionTracking';

import WaitLayout from '../layouts/WaitLayout';
import WaitView from '../views/wait/WaitView';

const Wait: FC = () => {
    const {
        setOffers,
        setApplicationStage,
        runDecisioning,
        fetchApplication,
        runCreditCommitments,
        applicationId,
        applicationEmail,
        loanDetails,
        saveFinalStage,
    } = useContext(ApplicationContext);

    useConversionTracking(applicationEmail, 351873);

    useEffect(() => {
        mixpanel.track('Submit Fact Find', {
            'Loan amount': loanDetails.amount,
            'Loan term': loanDetails.term,
            'Loan purpose': loanDetails.purpose,
        });
    }, [loanDetails.amount, loanDetails.term, loanDetails.purpose]);

    useEffect(() => {
        trackCometlyFactFindSubmitted(applicationId, applicationEmail);
    }, [applicationId, applicationEmail]);

    return (
        <WaitLayout>
            <WaitView
                fetchApplication={fetchApplication}
                setOffers={setOffers}
                setApplicationStage={setApplicationStage}
                runDecisioning={runDecisioning}
                runCreditCommitments={runCreditCommitments}
                applicationId={applicationId}
                saveFinalStage={saveFinalStage}
            />
        </WaitLayout>
    );
};

export default Wait;
